import {Component, Input} from '@angular/core';
import {InputBoxComponent} from '../input-box/input-box.component';

import { TooltipDirective } from '../../../Directives/tooltip.directive';
import { FormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'ins-multiline-box',
    templateUrl: './multiline-box.component.html',
    styleUrls: ['./multiline-box.component.scss', '../shared-UI-components.scss'],
    imports: [TooltipDirective, FormsModule, MatIcon]
})
export class MultilineBoxComponent extends InputBoxComponent  {
  @Input() numberOfLines: number;
  constructor() {
    super();
  }
}
